import React from "react";
import { Box, CircularProgress } from "@mui/material";

const MONO = "'IBM Plex Mono', monospace";

// Covers the drawing canvas while the pipeline is running, so partial/incomplete
// elements never render mid-processing — only once isProcessing flips false.
const ProcessingOverlay = ({ message }) => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      zIndex: 50,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
      background: "rgba(10,19,38,.94)",
    }}
  >
    <CircularProgress size={36} sx={{ color: "#2dd4bf" }} />
    <Box sx={{ fontFamily: MONO, fontSize: "13px", color: "#2dd4bf", letterSpacing: ".02em" }}>
      {message || "Processing drawing…"}
    </Box>
    <Box sx={{ fontFamily: MONO, fontSize: "11px", color: "#5f7398" }}>
      This drawing isn't ready yet — results will appear once processing finishes.
    </Box>
  </Box>
);

export default ProcessingOverlay;
